// 10 minutes
export const InvityAPIReloadDataAfterMs = 10 * 60 * 1000;
